/**
 * i18n public surface.
 *
 * - `Lang` — set of supported languages.
 * - `Translations` — canonical shape derived from `pt.ts`. Other locales
 *   import this type to guarantee shape parity; if a key is missing or has
 *   the wrong type, the TypeScript build fails.
 * - `interpolate` — minimal {{var}} substitution used by labels that need
 *   to inject the brand name or other runtime values.
 */
import pt from './locales/pt';

export const SUPPORTED_LANGS = ['pt', 'en', 'es'] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

export type Translations = typeof pt;

export function interpolate(
  template: string,
  vars: Record<string, string | number | undefined>
): string {
  return template.replace(/\{\{(\w+)\}\}/g, (_, key) => {
    const value = vars[key];
    return value === undefined ? '' : String(value);
  });
}

export { I18nProvider, useTranslation } from './I18nProvider';
export { LanguageSwitcher } from './LanguageSwitcher';
